export default __webpack_public_path__ + "static/media/email_preference.dbe7ee24.svg";